function DataPage(){
    return(
        <div>
            <h1>Data Page</h1>
        </div>
    )
}
export default DataPage;